import { IConfigService } from './config';
import { TokenService } from './authentication/TokenService';

import IHttpService = angular.IHttpService;
import IRequestConfig = angular.IRequestConfig;
import IHttpPromise = angular.IHttpPromise;

export interface IHttpWrapperService {
  $http<T = any>(config: IRequestConfig): IHttpPromise<T>;
  $ajax(url: string, config?: any): any;
}

export class HttpService implements IHttpWrapperService {
  private http: IHttpService;
  private tokenService: app.services.authentication.TokenService;

  constructor(
    $http: IHttpService,
    tokenService: app.services.authentication.TokenService
  ) {
    this.http = $http;
    this.tokenService = tokenService;
  }

  $http<T = any>(config: IRequestConfig): IHttpPromise<T> {
    return this.http(config);
  }

  $ajax(url: string, config?: any): any {
    const token = this.tokenService.GetAccessToken();
    const mergedConfig = {
      ...config,
      headers: {
        ...(config?.headers ?? {}),
        ...(token ? { Authorization: 'Bearer ' + token } : {})
      }
    };
    return $.ajax(url, mergedConfig);
  }
}

frontendApp.factory('HttpService', ['$http', 'TokenService',
  function($http: IHttpService, tokenService: app.services.authentication.TokenService) {
    return new HttpService($http, tokenService);
  }
]);
